import React, { useState } from 'react';
import AgentExecutorDetail from '../RunStatusLog/components/AgentExecutorDetail';
import AgentDetail from '../AgentDetail';
import ModalWarning from 'Common/Components/ModalWarning';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { closeModal } from 'store/modals/actions';
import { MODAL_AGENT_TRIGGER_WARNING, MODAL_TAGS_IN_AGENTS } from 'store/modals/modals';
import RecordsRepresentation from './RecordsRepresentation';
import { Wrapper } from './styled';
import SuccessPopup from 'Common/Components/SuccessPopup';
import { clearSuccessMessage, setTagsAgent } from 'store/Agents/actions';
import { SelectShowCloudAgents, selectAgentSuccess, selectAssetsTags, selectServicesTags, selectVulnsTags } from 'store/Agents/selectors';
import TagsModal from '../AgentDetail/components/TagsModal';
import { selectGeneralHostsTags, selectGeneralServicesTags, selectGeneralVulnsTags } from 'store/Tags/selectors';
import selectModal from 'store/modals/selectors';

const Content = ({ showGridView, selectedTab, showAgentDetail, showTriggerWarning }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [triggerWarning, setTriggerWarning] = useState('');
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const warningKeyPrefix = showCloudAgents ? 'cloudAgent.runAgent.warning' : 'agent.runAgent.warning';
  const warningMessage = triggerWarning ? intl.formatMessage({ id: `${warningKeyPrefix}.${triggerWarning}` }) : '';
  const warningTitle = intl.formatMessage({ id: `${warningKeyPrefix}.title` });
  const successMessage = useSelector(selectAgentSuccess);
  const vulnsOptions = useSelector(selectGeneralVulnsTags);
  const hostsOptions = useSelector(selectGeneralHostsTags);
  const servicesOptions = useSelector(selectGeneralServicesTags);
  const assetsTagsAdded = useSelector(selectAssetsTags);
  const vulnsTagsAdded = useSelector(selectVulnsTags);
  const servicesTagsAdded = useSelector(selectServicesTags);
  const showTagsModal = useSelector((state) => selectModal(state, MODAL_TAGS_IN_AGENTS));

  const closeTriggerWarning = () => {
    dispatch(closeModal(MODAL_AGENT_TRIGGER_WARNING));
    setTriggerWarning('');
  };

  const saveTags = (data) => {
    dispatch(setTagsAgent(data));
  };

  return (
    <Wrapper>
      <RecordsRepresentation showGridView={ showGridView } selectedTab={ selectedTab } />
      <AgentExecutorDetail />
      {showAgentDetail && <AgentDetail setTriggerWarning={ setTriggerWarning } /> }
      {showTriggerWarning ? <ModalWarning onCloseCallback={ closeTriggerWarning } title={ warningTitle } description={ warningMessage } /> : null}
      {successMessage && <SuccessPopup message={ successMessage } close={ () => dispatch(clearSuccessMessage()) } /> }
      { showTagsModal &&
        <TagsModal
          vulnsOptions={ vulnsOptions }
          hostsOptions={ hostsOptions }
          servicesOptions={ servicesOptions }
          assetsTagsAdded={ assetsTagsAdded }
          vulnsTagsAdded={ vulnsTagsAdded }
          servicesTagsAdded={ servicesTagsAdded }
          saveTags={ saveTags }
        />
      }
    </Wrapper>
  );
};

export default Content;
